export const getPlayerInfo  = () => {
  return fetch(`${process.env.REACT_APP_BACKEND_URL}/artifacts/users/me`, {
    method: 'GET',
    headers: {
      authorization: sessionStorage.getItem('firebaseToken'),
      'Content-Type': 'application/json',
    }
  } as any).then((res) => res.json())
}

export const checkEmailExist  = (email: string) => {
  return fetch(`${process.env.REACT_APP_BACKEND_URL}/artifacts/users/email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email
    })
  } as any).then((res) => res.status)
}
export const updateProfile  = (data: any) => {
  return fetch(`${process.env.REACT_APP_BACKEND_URL}/artifacts/users/profile`, {
    method: 'POST',
    headers: {
      authorization: sessionStorage.getItem('firebaseToken'),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  } as any).then((res) => res.status)
}